import { useState } from "react";

import { HorizontalDotsSVG, Icon } from "@newsela/angelou";

import { BannerMode } from "@/types/BannerMode.interface";
import { Assignment } from "@/types/models/Assignment.interface";
import ContentLevel from "@/types/models/ContentLevel.interface";
import { EventProperties } from "@/types/models/EventProperties.interface";
import { User } from "@/types/models/User.interface";
import { ArticleType } from "@/view/constants/articleTypes";
import { ContentType } from "@/view/constants/contentTypes";
import SecondaryActions from "@/view/SecondaryActions/";
import { DISABLED_FEATURES } from "@/view/SecondaryActions/SecondaryActions";
import SecondaryActionButton from "@/view/SecondaryActionsToolbar/SecondaryActionButton";

interface MobileActionsInterface {
  bannerMode: BannerMode;
  content: {
    id: string;
    content_type: ContentType;
    data?: {
      article_type: ArticleType;
      content_id: string;
      thumbnail: string;
    };
  };
  currentLevel: ContentLevel | undefined;
  matchedAssignments: Assignment[];
  user: User;
  userProperties: {
    isTeacher: boolean;
    isParent: boolean;
    isStudent: boolean;
  };
  disabledFeatures?: DISABLED_FEATURES[];
}

const MobileActions = ({
  bannerMode,
  content,
  currentLevel,
  matchedAssignments,
  user,
  userProperties,
  disabledFeatures = [],
}: MobileActionsInterface) => {
  const [activeSubMenu, setActiveSubMenu] = useState(null);

  const popOutContents = (
    <SecondaryActions
      activeSubMenu={activeSubMenu}
      bannerMode={bannerMode}
      content={content}
      currentLevel={currentLevel}
      isMenuAction
      isMobile
      matchedAssignments={matchedAssignments}
      setActiveSubMenu={setActiveSubMenu}
      user={user}
      userProperties={userProperties}
      disabledFeatures={disabledFeatures}
    />
  );

  const icon = (
    <Icon
      isDecorative={false}
      size="MD"
      title="More actions"
      SvgComponent={HorizontalDotsSVG}
    />
  );

  const eventProperties: EventProperties = {
    objectType: "Content",
    actionPrefix: "Initiate",
    actionName: "Interact",
    streamProperties: {
      content_type: content.content_type,
      description: "Toggle mobile actions",
      content_id: currentLevel?.id || content.id,
    },
  };

  return (
    <SecondaryActionButton
      ariaProps={{ "aria-label": "View more actions" }}
      horizontalPopOutPosition="LEFT"
      icon={icon}
      title="mobile-actions"
      popOutContents={popOutContents}
      eventProperties={eventProperties}
    />
  );
};

export default MobileActions;
